module.exports = __webpack_public_path__ + "static/media/Home.074d25d3.png";